module.exports = __webpack_public_path__ + "static/media/republican.8b22c16a.svg";